<template>
	<v-app-bar
		app
		color="white"
		height="40"
		elevation="2"
	>
		<!-- toggle drawer -->
		<v-btn
			text
			fab
			small
			@click="$emit('change-drawer')"
			class="me-2"
		>
			<v-icon>mdi-menu</v-icon>
		</v-btn>
		
		<!-- title -->
		<h1 class="text-md-h5 text-h6 primary--text font-weight-medium text-capitalize">
			{{$T(`routes.${$route.meta.i18nTranslateKey}`)}}
		</h1>
		<v-spacer/>
	
		<!-- notification & settings & lang -->
		<div class="d-flex align-center align-self-stretch">
			<template>
				<!-- experimental-simulation -->
				<v-btn
					v-if="permissions.managingExperimentalSimulation.isReadWrite || permissions.managingExperimentalSimulation.isReadonly"
					width="34"
					height="34"
					min-width="0"
					depressed
					rounded
					exact
					text
					:to="{ name: 'experimental-simulation' }"
					class="me-3 px-0"
				>
					<v-icon color="primary">mdi-network-pos</v-icon>
				</v-btn>
				
				<!-- material-simulation -->
				<v-btn
					v-if="permissions.managingMaterialSimulation.isReadWrite || permissions.managingMaterialSimulation.isReadonly"
					width="34"
					height="34"
					min-width="0"
					depressed
					rounded
					exact
					text
					:to="{ name: 'material-simulation' }"
					class="px-0"
				>
					<v-icon color="primary">mdi-scale-unbalanced</v-icon>
				</v-btn>

				<v-divider vertical inset class="ms-3 me-1"/>
			</template>
			
			<!-- language -->
			<v-menu offset-y :close-on-content-click="false">
				<!-- menu activator -->
				<template v-slot:activator="{ attrs, on }">
					<v-btn
						text
						class="px-1 text-capitalize me-1"
						v-bind="attrs"
						v-on="on"
					>
						<v-avatar size="35">
							<v-icon>mdi-web</v-icon>
						</v-avatar>
						<span class="me-1 text-uppercase">
							{{$i18n.locale}}
						</span>
						<v-icon>mdi-chevron-down</v-icon>
					</v-btn>
				</template>
	
				<!-- menu content -->
				<v-list nav dense>
					<v-list-item
						:class="{ 'grey lighten-2': $i18n.locale === 'en' }"
						@click="changeLang('en')"
					>
						<v-list-item-title>En - English</v-list-item-title>
					</v-list-item>
	
					<!-- logout -->
					<v-list-item
						:class="{ 'grey lighten-2': $i18n.locale === 'es' }"
						@click="changeLang('es')"
					>
						<v-list-item-title>ES - Española</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>

			<v-btn icon @click="goToSelectSystem()">
				<v-icon color="primary"> mdi-swap-horizontal </v-icon>
			</v-btn>

			<!-- user menu -->
			<v-menu offset-y :close-on-content-click="false">
				<!-- menu activator -->
				<template v-slot:activator="{ attrs, on }">
					<v-btn
						text
						class="px-3 text-capitalize"
						v-bind="attrs"
						v-on="on"
					>
						<v-avatar size="35">
							<v-icon>mdi-account</v-icon>
						</v-avatar>
						<span class="mx-2">
							{{username}}
						</span>
						<v-icon>mdi-chevron-down</v-icon>
					</v-btn>
				</template>
	
				<!-- menu content -->
				<v-list nav dense>
					<!-- change password -->
					<v-list-item @click="$emit('change-password')">
						<v-list-item-icon class="me-3"><v-icon>mdi-lock-reset</v-icon></v-list-item-icon>
						<v-list-item-title>{{ $T('components.change-password') }}</v-list-item-title>
					</v-list-item>
	
					<!-- logout -->
					<v-list-item @click="logout">
						<v-list-item-icon class="me-3"><v-icon>mdi-logout</v-icon></v-list-item-icon>
						<v-list-item-title>{{ $T('logout') }}</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>
		</div>
	</v-app-bar>
</template>

<script>
import { changeLang } from '@/i18n/i18n';
import { mapState } from 'vuex';
export default {
	name: 'Navbar',

	computed: {
		...mapState({
			username: state => state.auth.self.username,
			isAdmin: state => state.auth.self.isAdmin,
			permissions: state => state.auth.self.permissions
		})
	},

	methods: {
		logout() {
			this.$store.dispatch('auth/logout');
			this.$router.replace({ name: 'login' })
		},

		goToSelectSystem() {
			window.location.href = 'https://ugarit-systems.mirta.net' 
		},

		changeLang
	}
};
</script>

<style>
</style>